import styled from 'styled-components';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

export const StyledList = styled(List)`
  padding-top: 16px;

  a {
    width: 100%;
  }

  .MuiPaper-root.MuiCard-root {
    position: relative;
    border-radius: 8px;
    z-index: 3;
  }
`;

export const StyledListItem = styled(ListItem)`
  padding: 8px 0;
`;

export const ClassificationCodeContainer = styled.div`
  width: 24px;
  display: flex;
  justify-content: flex-end;
`;

export const Aside = styled.div`
  padding-left: 8px;
  margin-left: auto;
  color: #999999;
  max-width: 120px;
  align-items: center;
  display: flex;
  overflow: hidden;
  justify-content: flex-end;

  @media (max-width: 350px) {
    padding-left: 0;
  }
`;

export const StyledIconLine = styled.div`
  display: flex;
  align-items: center;
  color: #666;
  font-size: 12px;
  line-height: 16px;
  margin: 0 0 4px;

  & > svg {
    fill: #b3b3b3;
    font-size: 16px;
  }

  & > div,
  & > p {
    width: calc(100% - 50px);
    margin-left: 8px;
  }
`;

export const StyledIconLineList = styled(StyledIconLine)`
  margin-top: 5px;
`;

export const StyledTextList = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
`;

export const StyledButton = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  width: calc(50% - 8px);
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  padding-left: 32px;

  & > svg {
    position: absolute;
    left: 12px;
  }

  & > p {
    font-size: 14px;
    white-space: nowrap;
    text-align: center;
    text-transform: uppercase;
  }

  & > svg,
  > p {
    opacity: ${({ disabled }) => (disabled ? '0.2' : '1')};
  }
`;
